import { Directive, ElementRef, ViewContainerRef, NgZone, Inject, Input } from '@angular/core';
import { MatTooltip, MatTooltipDefaultOptions, MAT_TOOLTIP_SCROLL_STRATEGY } from '@angular/material/tooltip';
import {
  Overlay,
} from '@angular/cdk/overlay';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { Platform } from '@angular/cdk/platform';
import { AriaDescriber, FocusMonitor } from '@angular/cdk/a11y';
import { Directionality } from '@angular/cdk/bidi';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TooltipReaderService } from 'src/app/services/speech/tooltip-reader.service';

export const defaultOps: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  touchendHideDelay: 1500,
  disableTooltipInteractivity: true,
};

@Directive({
    selector: '[asgTooltip]',
    standalone: true
})
export class TooltipDirective extends MatTooltip {
  private $value: string;
  private sub: Subscription;
  @Input('asgTooltip')
  set _tooltipText(value: string) {
    if (this.$value !== value) {
      this.$value = value;
    }

    if (this.$value) {
      this.sub = this.translate.get(`TOOLTIPS.${this.$value}`).subscribe(e => {
        this.message = e;
        if (this.sub) {
          this.sub.unsubscribe();
        }
      });
    } else {
      this.message = '';
    }
  }
  constructor(
    public $Overlay: Overlay,
    public $ElementRef: ElementRef,
    public $ScrollDispatcher: ScrollDispatcher,
    public $ViewContainerRef: ViewContainerRef,
    public $NgZone: NgZone,
    public $Platform: Platform,
    public $AriaDescriber: AriaDescriber,
    public $FocusMonitor: FocusMonitor,
    public $Directionality: Directionality,
    @Inject(MAT_TOOLTIP_SCROLL_STRATEGY) $scrollStrategy: any,
    private translate: TranslateService,
    private tooltipReaderService: TooltipReaderService
  ) {

    super(
      $Overlay, $ElementRef, $ScrollDispatcher, $ViewContainerRef, $NgZone, $Platform, $AriaDescriber, $FocusMonitor,
      $scrollStrategy, $Directionality, defaultOps, null
    );

    this.translate.onLangChange.subscribe((e: LangChangeEvent) => {
      if (e.lang !== this.$value) {
        this._tooltipText = this.$value;
      }
    });
  }

  show() {
    super.show();
    this.tooltipReaderService.readTooltip(this.message);
  }

  hide() {
    super.hide();
    // this.tooltipReaderService.nevermind(this.message);
  }
}
